export default {"src":"/_next/static/media/rocket.b11dea0c.svg","height":1500,"width":1500,"blurWidth":0,"blurHeight":0};